import React, { Component } from 'react';
import { Input, Icon } from 'antd';

import { inject, observer } from 'mobx-react';

import { MagnifierIcon } from '../../../../../common/icons';

import './FullTextSearch.css';

@inject('carsStore')
@observer
export default class FullTextSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fullTextSearch: null,
    };
  }

  componentWillUnmount = () => {
    this.emitEmpty();
  };

  componentDidMount() {
    if (this.props.carsStore.fullTextSearch) {
      this.init(this.props.carsStore.fullTextSearch);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      this.emitEmpty();
    }
  }

  init(filters) {
    this.setState({ fullTextSearch: filters });
  }

  search = () => {
    const { carsStore } = this.props;
    carsStore.setFullTextSearch(this.state.fullTextSearch);
  };

  keyPress = e => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  emitEmpty = () => {
    const { carsStore } = this.props;
    this.setState({ fullTextSearch: null }, () => {
      carsStore.setFullTextSearch(this.state.fullTextSearch);
    });
  };

  onChange = e => {
    this.setState({ fullTextSearch: e.target.value });
  };

  render() {
    const suffix = this.props.carsStore.fullTextSearch ? <Icon type="close-circle" onClick={this.emitEmpty} style={{ color: 'white' }} /> : null;
    return (
      <div className="FullTextSearch">
        <Input
          placeholder={this.props.placeholder}
          prefix={<MagnifierIcon onClick={this.search} />}
          value={this.state.fullTextSearch}
          onChange={this.onChange}
          onKeyDown={this.keyPress}
          suffix={suffix}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/SubHeader/FullTextSearch/FullTextSearch.js